export function buildMentionFlatItems(mentionUsers, mentionAgentsList) {
  return [
    ...mentionUsers.map((u) => ({ ...u, kind: 'user' })),
    ...mentionAgentsList.map((a) => ({ ...a, kind: 'agent' })),
  ]
}
